// extracted by extract-css-chunks-webpack-plugin
module.exports = {"socialButtons":"RpaBwXKSCU3b"};